import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import {
  ActionRule,
  ProcessDefinition,
} from '@flowx/designer/modules/core/dictionary/process.dictionary'

import { ApiHttpService } from './api-http.service'

import { UrlParametersStoreService } from '../services/url-parameters-store.service'

@Injectable({
  providedIn: 'root',
})
export class ActionTestApi extends ApiHttpService {
  #urlParametersStoreService = inject(UrlParametersStoreService)
  #processApiPath = inject<string>('PROCESS_API_PATH' as any)

  constructor() {
    super(inject<string>('BASE_URL' as any), inject(HttpClient))
  }

  testRule(
    processId: ProcessDefinition['id'],
    actionRule: Pick<
      ActionRule,
      'expression' | 'language' | 'businessRuleReferences' | 'useGraalVM'
    >,
    data: Record<string, any>
  ): Observable<any> {
    const processApiPath = this.#processApiPath?.replace('/', '')
    const url = `${processApiPath ? `${processApiPath}/` : ''}api/test/action-rules`
    const { appId, appVersionId } = this.#urlParametersStoreService.urlParameters
    return this.post(url, {
      actionRule,
      appId,
      buildId: appVersionId,
      processId,
      params: data,
    })
  }
}
